import { useCustomT } from '@crimeos-frontend/shared/common'

import { FileUploadSignedUrl } from '../../../types/FileUploadTypes'
import { showFailureToastWithGivenMessage } from '../../../utils/ToastUtils'
import { GetSignedUploadUrlsQuery as Query } from './query.generatedTypes'

interface ReturnType {
  handleAPIResponse: (
    response: Query,
    onSuccess: (fileNameWithSignedUploadUrls: FileUploadSignedUrl[]) => void
  ) => void
}

const useAPIResponseHandler = (): ReturnType => {
  const errorT = useCustomT('common:apiErrorMessages')

  const handleAPIResponse = (
    response: Query,
    onSuccess: (fileNameWithSignedUploadUrls: FileUploadSignedUrl[]) => void
  ): void => {
    const getSignedUploadUrls = response.getSignedUploadUrls

    switch (getSignedUploadUrls.__typename) {
      case 'GetSignedUploadUrlsResult': {
        onSuccess(getSignedUploadUrls.fileNameWithSignedUploadUrls)
        break
      }

      case 'FileUploadEntityNotFound':
      case 'FileUploadEntityAccessDenied':
      case 'MaxSignedUploadUrlFileCountIsExceeded':
      case 'ErrorOccurWhileGeneratingPreSignedUrls': {
        const errorMessage =
          getSignedUploadUrls.message ||
          errorT(`${getSignedUploadUrls.__typename}`)

        showFailureToastWithGivenMessage(errorMessage)
        break
      }

      default:
        throw new Error(`__typename: Invalid GetSignedUploadUrls Response type`)
    }
  }

  return { handleAPIResponse }
}

export default useAPIResponseHandler
